export default __webpack_public_path__ + "static/media/studentMangement.f982a221.png";